import { ComponentProps, FC } from 'react'
import { BrowserRouter } from 'react-router-dom'

function RouterProvider({ children }: ComponentProps<FC>): JSX.Element {
  return <BrowserRouter>{children}</BrowserRouter>
}

export default RouterProvider
